class AdventCalendar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.canvas = this.els.canvas.element
    this.context = this.canvas.getContext('2d')

    this.containerRect = this.els.container.element.getBoundingClientRect()

    this.canvas.width = this.containerRect.width
    this.canvas.height = this.containerRect.height

    this.particles = []

    this.initParticles()
    this.animate()

    this.hasVisitedBefore = window.sessionStorage.getItem('hasVisitedBefore')

    if (!window.theme.customer.isLoggedIn || this.hasVisitedBefore) {
      return
    }

    setTimeout(() => {
      this.scrollToCurrentRow()
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.onResize.bind(this))
  }

  scrollToCurrentRow () {
    const rowToScrollDesktop = this.dataset.rowToScrollDesktop

    const adventFirstRowDesktop = this.els.container.element.querySelector(
      `${rowToScrollDesktop}`,
    )

    const rowToScrollMobile = this.dataset.rowToScrollMobile

    const adventFirstRowMobile = this.els.container.element.querySelector(
      `${rowToScrollMobile}`,
    )

    if (window.innerWidth <= window.BAO.MediaBreakpoints.breakpoints.md) {
      adventFirstRowMobile.scrollIntoView({ behavior: 'smooth' })
    } else {
      adventFirstRowDesktop.scrollIntoView({ behavior: 'smooth' })
    }

    window.sessionStorage.setItem('hasVisitedBefore', true)
  }

  onResize () {
    this.particles = []

    this.canvas.width = this.containerRect.width
    this.canvas.height = this.containerRect.height

    this.initParticles()
  }

  initParticles () {
    const particleAmount = 300
    Array.from({ length: particleAmount }).forEach(() => {
      this.particles.push(
        new Particle(
          Math.random() * this.canvas.width,
          Math.random() * this.canvas.height,
          this.randomIntFromRange(0.5, 3),
          this.randomColor(['#ccc', '#eee', '#fff', '#ddd']),
          Math.random() * 80,
          this.context,
        ),
      )
    })
  }

  randomIntFromRange (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  randomColor (colors) {
    return colors[Math.floor(Math.random() * colors.length)]
  }

  animate () {
    requestAnimationFrame(this.animate.bind(this))
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)

    this.particles.forEach(particle => {
      particle.update()
    })
  }
}

class Particle {
  constructor (x, y, radius, color, radians, context) {
    this.initialX = x
    this.initialY = y
    this.x = x
    this.y = y
    this.radius = radius
    this.color = color
    this.radians = radians
    this.context = context
    this.velocity = 0.001
  }

  update () {
    this.radians += this.velocity
    this.x = this.initialX + Math.cos(this.radians) * 400
    this.y = this.initialY + Math.tan(this.radians) * 600

    this.draw()
  }

  draw () {
    this.context.beginPath()
    this.context.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
    this.context.fillStyle = this.color
    this.context.fill()
    this.context.closePath()
  }
}

if (!customElements.get('advent-calendar')) {
  customElements.define('advent-calendar', AdventCalendar)
}
